import { Button, Col, Divider, Popover, Row } from 'antd'
import React, { useEffect, useState } from 'react'
import axios from 'axios'
import Qs from 'qs'


import { UserOutlined, LogoutOutlined } from '@ant-design/icons'

import Cookies from 'js-cookie'
import userStyles from './user.module.less'

import './user-center.css'
import localStorage from 'localStorage'
import { sendHttpPostRequest } from '../../../api/http-request'
import {
  delCookie,
  getCookie,
} from '../../../component/modal/login-register/login-register'
import { BACKEND_API_URL } from '../../../constants/constants'
import * as constants from '../../../constants/constants'
import { useLocation } from 'react-router-dom'
export interface Props {}
let globalUserLogin = false

/**
 * UserInfo
 * 用户信息
 */
export const UserInfo: React.FC<Props> = (props) => {
  const location = useLocation();
  const [userLogin, setUserLogin] = useState(false) // 登录 false / true
  const [userId, setUserId] = useState(0) // 用户id
  const [userName, setUserName] = useState('') // 用户昵称

  const [collegeId, setCollegeId] = useState(0) // 院校ID
  const [collegeName, setCollegeName] = useState('') // 院校名称
  const [collegeInfo, setCollegeInfo] = useState(null as any) //查询当前用户的机构信息,is_college_teacher weitrue表示是教师，
  const [isManager, setIsManager] = useState(0) // 是否是院校管理员


  const [userAvatar, setUserAvatar] = useState(
    '/static/image/avatar/default_avatar.png'
  ) // 用户头像

  useEffect(() => {
    const hasLocal = getUserInfoFromLocal()
    // 无论本地缓存是否存在，都向后端验证登录状态
    checkLogin()
    const sessionid = Cookies.get('sessionid')
    if (sessionid) {
      sendHttpPostRequest(
        'account/api/query_teacher_authenticate',
        {
          sessionid: sessionid,
          sid: sessionid,
        },
        (response: any) => {
          if (response.is_ok == true) {
            if (response?.college_id !== 0) {
              //已加入机构
              let _collegeId = response.college_info.college_id
              setCollegeId(_collegeId)
              setCollegeInfo(response.college_info)
              setCollegeName(response.college_info.college_name)
              setIsManager(response.college_info.is_manager)
            } else {
              //未加入机构
              setCollegeId(0)
            }
          } 
        }
      )
    }
  }, [])

  /*useEffect(() => {
    getUserInfoFromLocal()
    return () => {}
  }, [JSON.parse(localStorage.getItem('user_info'))])*/

  // 从本地获取用户信息
  const getUserInfoFromLocal = () => {
    try {
      // 如果 sessionid cookie 不存在，说明未登录，清除本地缓存
      if (!Cookies.get('sessionid')) {
        localStorage.removeItem('user_info')
        return false
      }
      const user_info = JSON.parse(localStorage.getItem('user_info'))
      if (!user_info) {
        return false
      } else {
        setUserLogin(true)
        setUserId(user_info.login_user_id)
        setUserName(user_info.login_user_name)
        setUserAvatar(user_info.login_user_avatar)
        globalUserLogin = true
        return true
      }
    } catch (e) {
      console.error(e)
      return false
    }
  }

  /**
   * 校验用户是否登录
   */
  const checkLogin = () => {
    const sessionid = Cookies.get('sessionid')
    if (sessionid) {
      const _data = Qs.stringify({
        sessionid: sessionid,
      })
      const _headers = {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      }
      axios
        .post(
          constants.BACKEND_API_URL + 'account/api/check_login/',
          _data,
          _headers
        )
        .then((response: any) => response.data)
        .then((data: any) => {
          if (data && data.login_user_id) {
            setUserLogin(true)
            setUserId(data.login_user_id)
            setUserName(data.login_user_name)
            setUserAvatar(data.login_user_avatar)
            globalUserLogin = true
          } else {
            // 后端返回无效登录数据，清除本地状态
            setUserLogin(false)
            globalUserLogin = false
            localStorage.removeItem('user_info')
          }
          // localStorage.setItem("user_info", JSON.stringify(data));
          console.log('登录成功')
          // console.log(data);
        })
        .catch((e) => {
          console.error(':)校验失败了', e)
        })
    } else {
      console.log('用户未登录')
    }
  }

  const content = (
    <>
      <div style={{ textAlign: 'center', padding: '8px 0 4px' }}>
        <img
          style={{ height: 48, width: 48, borderRadius: 24, border: '2px solid rgba(46,81,84,0.1)' }}
          src={BACKEND_API_URL + userAvatar}
        />
      </div>
      <div style={{ textAlign: 'center', fontSize: 15, fontWeight: 600, color: '#111827', padding: '6px 0 8px' }}>
        {userName}
      </div>

      <div
        className={userStyles.useCenterContentActionDiv}
        onClick={handleGoUserCenter.bind(userId)}
      >
        <Row
          align="middle"
          gutter={[0, 0]}
          style={{ paddingLeft: 20, paddingRight: 20, height: 40, margin: 0 }}
        >
          <Col style={{ margin: 0 }}>
            <UserOutlined style={{ marginRight: 10, color: '#6b7280' }} />
          </Col>
          <Col style={{ margin: 0 }}> 个人中心 </Col>
        </Row>
      </div>

      <div
        className={userStyles.useCenterContentActionDiv}
        onClick={handleGoLogout}
      >
        <Row
          align="middle"
          gutter={[0, 0]}
          style={{ paddingLeft: 20, paddingRight: 20, height: 40, margin: 0 }}
        >
          <Col style={{ margin: 0 }}>
            <LogoutOutlined style={{ marginRight: 10, color: '#6b7280' }} />
          </Col>
          <Col style={{ margin: 0 }}> 退出登录 </Col>
        </Row>
      </div>

      <Divider className={userStyles.divider}></Divider>
      <div className={userStyles.userBotm}>
        <div className={userStyles.btmTitle}>当前机构</div>
        <div className={userStyles.institution}>
          <Row justify="space-between" align={'middle'} wrap={false}>
            <Col className={userStyles.collegeNameContain}>
              {collegeName == ''
                ? '无'
                : collegeName}
            </Col>
            
            <Col>
            { 
              isManager == 1 && 
              <Button
                style={{ boxShadow:'none',textShadow:'none'}}
                type='link'
                size='small'
                onClick={()=>{window.open('/college-oam')}}
              >
              管理
              </Button>
            }

              <span
                style={{ cursor: 'pointer' }}
                className={userStyles.btmTitle}
                onClick={handleGoUserCenter.bind(userId)}
              >
                {!collegeName ? '设置>' : '切换>'}
              </span>
            </Col>
          </Row>
        </div>
      </div>

      
    </>
  )
  // console.log(userLogin)
  if (userLogin) {
    return (
      <Popover
        placement="bottomRight"
        title={''}
        content={content}
        trigger="hover"
        overlayClassName={userStyles.userPopver}
        overlayStyle={{ margin: 0, width: 250 }}
        overlayInnerStyle={{ marginTop: -10, paddingTop: 10, borderRadius: 16 }}
      >
        <div style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', padding: '4px 8px', borderRadius: 20, transition: 'background 0.2s', }}>
          <img id="header-user-avatar" src={BACKEND_API_URL + userAvatar} style={{ border: '2px solid rgba(46,81,84,0.1)' }} />
          <span id="header-user-name" style={{marginLeft:6, color: '#374151', fontWeight: 500, fontSize: 14}}>{userName}</span> 
          {/** location?.pathname?.includes("project_main") ? '#f2f2f2' :  */}
        </div>

      </Popover>
    )
  } else {
    return (
      <div>
          <Button style={{borderRadius:20, width:80, textShadow:'none', boxShadow:'none', background: '#3730a3', borderColor: '#3730a3', fontWeight: 500}} type="primary" onClick={handleGoLogin}>登录</Button>
      </div>
    )
  }
}

export default UserInfo

/**
 * 登录
 */
export function handleGoLogin() {
  document.getElementById('show-login-modal')!.click()
}

export function logoutCallback() {
  delCookie('sessionid')
  localStorage.removeItem('user_info')
  setTimeout(() => {
    window.location.reload()
  }, 100)
}

/**
 * 退出登录
 */
export function handleGoLogout() {
  const cookie = getCookie('sessionid')
  try {
    sendHttpPostRequest(
      'account/api/logout/',
      { sessionid: cookie },
      logoutCallback
    )
  } catch (e) {
    logoutCallback
  }
}

/**
 * 个人中心
 */
export function handleGoUserCenter() {
  window.location.href = '/user-center'
}

/**
 * 外部调用判断是否登录了
 */
export function checkUserLogin() {
  return globalUserLogin
}
